export default __webpack_public_path__ + "static/media/wmatic.f1dcdc4d.svg";